import axiosInstance from './axiosInstance';

export const getConfig = (key) => axiosInstance.get(`/SystemConfig/GetConfig?key=${key}`);
export const setConfig = (key, value) => axiosInstance.put("/SystemConfig/SetConfig", { key, value });
export const getApprovers = () => axiosInstance.get("/SystemConfig/GetApprovers");
